import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { EmployeeCostSetting } from '../../_models/financials/employeeCostSetting';
import { environment } from '../../../../environments/environment';

@Injectable()
export class EmployeeCostSettingService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  // Ottiene la lista di EmployeeCostSettings
  getList(): Observable<EmployeeCostSetting[]> {
    return this.http.get<EmployeeCostSetting[]>(
      `${this.apiBaseUrl}api/private/v1/financial/employeeCostSettings`
    );
  }

  // Ottiene un singolo EmployeeCostSetting per id
  get(id: number): Observable<EmployeeCostSetting> {
    return this.http.get<EmployeeCostSetting>(
      `${this.apiBaseUrl}api/private/v1/financial/employeeCostSettings/${id}`
    );
  }

  // Salva o aggiorna un EmployeeCostSetting
  save(employeeCostSettingItem: EmployeeCostSetting): Observable<EmployeeCostSetting> {
    const employeeCostSetting = { ...employeeCostSettingItem };
    delete employeeCostSetting.lastUpdated;
    delete employeeCostSetting.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    employeeCostSetting.companyId = companySelected ? companySelected.id : null;

    if (employeeCostSetting.user && employeeCostSetting.user.id) {
      employeeCostSetting.user = { id: employeeCostSetting.user.id };
    }

    if (employeeCostSetting.id) {
      return this.http.put<EmployeeCostSetting>(
        `${this.apiBaseUrl}api/private/v1/financial/employeeCostSettings/${employeeCostSetting.id}`,
        employeeCostSetting
      );
    } else {
      return this.http.post<EmployeeCostSetting>(
        `${this.apiBaseUrl}api/private/v1/financial/employeeCostSettings/`,
        employeeCostSetting
      );
    }
  }

  // Cancella un EmployeeCostSetting
  delete(employeeCostSetting: EmployeeCostSetting): Observable<EmployeeCostSetting> {
    return this.http
      .delete<void>(
        `${this.apiBaseUrl}api/private/v1/financial/employeeCostSettings/${employeeCostSetting.id}`
      )
      .pipe(map(() => ({ id: employeeCostSetting.id }) as EmployeeCostSetting));
  }
}
